export const BorderRadius = {
  small: '10px',
  medium: '14px',
  large: '18px',
};
